import { useProtected } from "@/hooks/useProtected";
import { Outlet } from "react-router-dom";

export const TenantDocumentsRoot = () => {
  useProtected();

  return <Outlet />;
};

export { DocumentsPage } from "./Documents";
export { DocumentPage } from "./Document";
